<template>
    <div class="header">
        <div class="nav table">
            <ul class="table-row">
                <li class="table-cell back-cell">
                    <slot name="left" v-if="left"></slot>
                    <router-link to="/" v-else style="visibility: hidden;">
                        &laquo;
                    </router-link>
                </li>
                <li class="table-cell logo">
                    <a>{{title}}</a>
                </li>
                <li class="table-cell back-cell">
                    <slot name="right" v-if="right"></slot>
                    <router-link to="/" v-else style="visibility: hidden;">
                        &laquo;
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['app', 'back', 'title', 'right', 'left']
};
</script>
